import { agency ,geoCode } from '../api';
import { getGeoLocation } from '../utility';
let offices;

export async function getGeoCode(keyword) {
  if (!keyword) {
    const { GeoLocation_Longitude, GeoLocation_Latitude } = await getGeoLocation();
    keyword = `{"lat":${GeoLocation_Latitude}, "lng":${GeoLocation_Longitude}}`;
  }
  return geoCode.getGeoCode(keyword);
}
export const getAgenciesInside = agency.getAgenciesInside;
export async function getAgenciesNearby(keyword, name) {
  const { GeoLocation_Longitude, GeoLocation_Latitude } = await getGeoLocation();
  return agency.getAgenciesNearBy('POINT(' + GeoLocation_Longitude + ' ' + GeoLocation_Latitude + ')', keyword, name);
}

// export async function getAllOffices() {
//   const { GeoLocation_Longitude, GeoLocation_Latitude } = await getGeoLocation();
//   if (!offices) {
//     offices = agency.getAgenciesNearBy('POINT(' + GeoLocation_Longitude + ' ' + GeoLocation_Latitude + ')','','');
//   }
//   return offices;
// }

export async function getAllOffices() {
  if (!offices) {
    offices = agency.getAllAgencys();
  }
  return offices;
}
